import { asCardWithIcon } from "../page-fragments";
import { filterableContentOf } from "../../utils/filterableContentOf";

export default filterableContentOf(
  asCardWithIcon.name,
  asCardWithIcon.toReadableText!
);
